/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Scim_Enterprise_Required_DescriptionInputs */



/**
* | output |
* | --- |
* | "SCIM provisioning is available on the Enterprise plan. Contact us to learn more." |
*
* @param {Admin_Settings_Scim_Enterprise_Required_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_settings_scim_enterprise_required_description = /** @type {((inputs?: Admin_Settings_Scim_Enterprise_Required_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Scim_Enterprise_Required_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("SCIM-Provisionierung ist im Enterprise-Plan verfügbar. Kontaktieren Sie uns, um mehr zu erfahren.")
	return /** @type {LocalizedString} */ ("SCIM provisioning is available on the Enterprise plan. Contact us to learn more.")
});